import { render, staticRenderFns } from "./AvatarSelect.vue?vue&type=template&id=f2398eec"
import script from "./AvatarSelect.js?vue&type=script&lang=js&external"
export * from "./AvatarSelect.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports